module.exports = __webpack_public_path__ + "img/PlatformComposition_Phone.a9162fd4.png";